import React, { useContext } from 'react';
import { css } from '@emotion/css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { FilterTaxonomy } from 'api/queries/filter';
import { DEFAULT_FILTER_PAGE, DrainContext, FilterCurrentElement } from 'contexts/DrainContext';
import { EMPTY_ELEMENT } from 'common/utils/react';
import { EMPTY_STRING, SPACE } from 'common/utils/string';

const classes = {
  root: css`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 100%;
  `,
  rootItem: css`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 57px;
    height: auto;
    padding: 13px 20px 10px 20px;
    border: 1px solid #f0eded;
  `,
  item: css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
  `,
  comment: css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
  `,
  default: {
    root: css`
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      width: 100%;
    `,
    title: css`
      font-weight: 400;
    `,
    action: css`
      color: #48096c;
      cursor: pointer;
      padding-top: 3px;
    `,
  },
  prompt: {
    root: css`
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    `,
    item: css`
      color: #276ef1;
      font-size: 14px;
      padding-right: 5px;
      :nth-child(2) {
        padding-right: 0;
      }
    `,
    comment: css`
      padding-left: 10px;
    `,
  },
};

type Props = {
  list: FilterTaxonomy;
};

export const FilterDefault: React.FC<Props> = ({ list }) => {
  const drain = useContext(DrainContext);

  return (
    <div className={classes.root}>
      {Object.keys(list.elements).map((taxonomyCodeName: string) => {
        const filterLength = drain.filter.elements.filter(
          ({ parent: { codename } }: FilterCurrentElement) => codename === taxonomyCodeName
        ).length;
        let displayValueCount = 0;
        return list.elements[taxonomyCodeName].switched ? (
          <div
            className={classes.rootItem}
            onClick={() => {
              drain.setPage({
                code: taxonomyCodeName,
                parent: DEFAULT_FILTER_PAGE,
              });
            }}
          >
            <div className={classes.item}>
              <div className={classes.default.root}>
                <div className={classes.default.title}>{list.elements[taxonomyCodeName].question}</div>
                <div className={classes.default.action}>
                  <FontAwesomeIcon icon={['fas', 'angle-right']} />
                </div>
              </div>
            </div>
            <div className={classes.comment}>
              {filterLength > 0 ? (
                <div className={classes.prompt.root}>
                  {displayValueCount === 0 &&
                    drain.filter.elements.map(({ parent, name }: FilterCurrentElement) => {
                      if (parent.codename === taxonomyCodeName && displayValueCount < 2) {
                        displayValueCount++;
                        return (
                          <div className={classes.prompt.item} key={name}>
                            {`${name}${displayValueCount < 2 && filterLength !== 1 ? `,` : EMPTY_STRING}`}
                          </div>
                        );
                      }
                    })}
                  <div className={classes.prompt.comment}>
                    {filterLength > 2 ? `+${filterLength - 2} other` : void 0}
                  </div>
                </div>
              ) : (
                EMPTY_ELEMENT
              )}
            </div>
          </div>
        ) : (
          EMPTY_ELEMENT
        );
      })}
    </div>
  );
};
